function getBaseUrl(url: string): string {
	try {
		const urlObj = new URL(url);
		return `${urlObj.protocol}//${urlObj.host}${urlObj.pathname}`;
	} catch {
		const pathMatch = url.match(/^([^?]+)/);
		return pathMatch?.[1] || url;
	}
}

export function replaceUrlInMessage(message: string, oldUrl: string, newUrl: string): string {
	if (!oldUrl || !newUrl) return message;

	const baseUrl = getBaseUrl(oldUrl);
	const escapedBaseUrl = baseUrl.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	const urlPattern = new RegExp(`${escapedBaseUrl}(?:\\?[^\\s]*)?`, 'g');

	if (urlPattern.test(message)) {
		return message.replace(urlPattern, newUrl);
	}

	if (!message.includes(newUrl)) {
		return message ? `${message} ${newUrl}` : newUrl;
	}

	return message;
}
